<template>
  <div class="template-basicPage mb-0">
    <CookiePopup />
    <LanuageSelector @selectSpanish="langSpanish" />
    <div class="loginLink">
      <p v-html="$t('landing.register')"></p>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="openingParagraph">
            <h2 v-html="$t('landing.paraHeading')"></h2>
          </div>
        </div>
      </div>
      <div class="form">
        <div class="row">
          <div class="col-lg-12 text-center">
            <p class="openingPara" v-html="$t('landing.openingPara')"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="canonStream mb-0">
      <div class="fluidMedia" :class="{active : compatable}">
        <div class="virtualEvent" :class="{ active : virtualEvent}">
          <iframe width="100%" :src="canonVisonUrl" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <div class="popupMessage" :class="{ active : popupMessage}">
          <div class="form" style="padding: 0px; padding: 20px 5%;background-color: rgb(208 208 208)">
            <div class="row" style="padding: 0 30px;">
              <div class="col-lg-12 text-center" style="padding: 0px;">
                <p class="p-0 mb-3"><b>Canon Vision virtual trade show is a highly immersive 3D experience. For optimal performance, we advise visiting on a computer that meets the recommended specs.</b></p>
              </div>
              <div class="col-lg-6" style="padding-left: 0px;">
                <p style="margin-bottom: 0px;"><b>Minimum System Specs:</b></p>
                <ul style="padding-left: 20px;font-size: 14px;">
                  <li>64-bit operating system</li>
                  <li>4GB of RAM</li>
                  <li>Integrated graphics with WebGL 2.0 / OpenGL ES 3.0 Support</li>
                  <li>Dual-core Intel/AMD CPU</li>
                  <li>Internet Speed - 5mb Download</li>
                </ul>
              </div>
              <div class="col-lg-6" style="padding-right: 0px;padding-left: 0px;">
                <p style="margin-bottom: 0px;"><b>Recommended System Specs:</b></p>
                <ul style="padding-left: 20px;font-size: 14px;">
                  <li>64-bit operating system</li>
                  <li>8GB of RAM or higher</li>
                  <li>Dedicated NVIDIA/AMD GPU (Geforce 400 or Radeon HD 7000 Series or higher)</li>
                  <li>Quad-core Intel/AMD CPU (Intel Sandy Bridge or AMD Bulldozer Series or higher)</li>
                  <li>Internet Speed - 10mb Download</li>
                </ul>
              </div>
              <div class="col-lg-12 text-center">
                <p>If your computer meets the minimum spec, please click Enter.<br>If your computer doesn't meet the minimum spec, please click <a href="https://www.canon-europe.com/pro/events/canon-vision/web-version/?cache=no">here</a>.</p>
              </div>
            </div>
            <div class="actions">
              <!-- <button type="button" class="Btn" @click="clickDeclinePopup">Decline <i class="arrowRight fas fa-arrow-alt-circle-right"></i></button> -->
              <button type="button" class="Btn" @click="clickAcceptPopup">Enter <i class="arrowRight fas fa-arrow-alt-circle-right"></i></button>
            </div>
          </div>
        </div>
        <div class="popupMessage mobile" :class="{ active : popupMessage}">
          <div class="form" style="padding: 0px; padding: 20px 5%;background-color: rgb(208 208 208)">
            <div class="row">
              <div class="col-12">
                <img src="@/assets/images/landing/Canon_AR_Image.png" alt="">
                <p class="p-0 mb-3">
                  <b>Explore virtual products from anywhere with the free Reydar Augmented Reality app available on iOS and Android.</b>
                  <br>
                  Reydar requires a minimum of iPhone 6S using iOS 11.0 or a compatible Android phone using 8.0 Oreo to run.
                </p>
                <img class="ReydarLogoApp" src="@/assets/images/landing/Reydar_Download_Scan_Discover.png" alt="Reydar Download Scan Discover Logo">
                <a href="https://apps.apple.com/us/app/reydar/id1490477530">
                  <img class="AppDownload" v-if="operatingSystem === 'iOS'" src="@/assets/images/landing/App_Shop_Download.png" alt="Reydar App Store">
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.EngineCreative.ReydarApp">
                  <img class="AppDownload" v-if="operatingSystem === 'Android'" src="@/assets/images/landing/Play_Store_Download.png" alt="Reydar Google Play Store">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fluidMedia" :class="{active : !compatable}">
        <div class="popupMessage" :class="{ active : popupMessage}">
          <div class="form" style="padding: 0px; padding: 20px 5%;background-color: rgb(208 208 208)">
            <div class="actions">
              <p style="font-size: 1.2rem !important; line-height: 1rem !important;"><b>Uh-oh! It looks like your browser is currently not supported</b></p>
            </div>
            <div class="row" style="padding: 0 30px;">
              <div class="col-lg-12 text-center" style="padding: 0px;">
                <p class="p-0 mb-3">Canon Vision virtual trade show is a highly immersive 3D experience. Please re-visit using the latest version of <a target="_blank" rel="noopener noreferrer" href="https://www.google.com/chrome/">Chrome</a>, <span v-if="firefox"><a target="_blank" rel="noopener noreferrer" href="https://www.mozilla.org/firefox/new/">Firefox</a>,</span> <a target="_blank" rel="noopener noreferrer" href="https://www.microsoft.com/edge">Edge</a> or <a target="_blank" rel="noopener noreferrer" href="https://www.opera.com/download">Opera</a> browsers.</p>
                <p>If you do not have one of these browsers, please click <a href="https://www.canon-europe.com/pro/events/canon-vision/web-version/?cache=no">here</a> for a 2D version of the experience.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="popupMessage mobile" :class="{ active : popupMessage}">
          <div class="form" style="padding: 0px; padding: 20px 5%;background-color: rgb(208 208 208)">
            <div class="row">
              <div class="col-12">
                <img src="@/assets/images/landing/Canon_AR_Image.png" alt="">
                <p class="p-0 mb-3">
                  <b>Explore virtual products from anywhere with the free Reydar Augmented Reality app available on iOS and Android.</b>
                  <br>
                  Reydar requires a minimum of iPhone 6S using iOS 11.0 or a compatible Android phone using 8.0 Oreo to run.
                </p>
                <img class="ReydarLogoApp" src="@/assets/images/landing/Reydar_Download_Scan_Discover.png" alt="Reydar Download Scan Discover Logo">
                <a href="https://apps.apple.com/us/app/reydar/id1490477530">
                  <img class="AppDownload" v-if="operatingSystem === 'iOS'" src="@/assets/images/landing/App_Shop_Download.png" alt="Reydar App Store">
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.EngineCreative.ReydarApp">
                  <img class="AppDownload" v-if="operatingSystem === 'Android'" src="@/assets/images/landing/Play_Store_Download.png" alt="Reydar Google Play Store">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container" style="margin-top: 60px;">
      <div class="form">
        <div class="row">
          <div class="col-lg-6 mb-60 paraSection">
            <h3 v-html="$t('landing.paraHeading')"></h3>
            <p v-html="$t('landing.paraBody')"></p>
            <button type="button" class="Btn" @click="clickVideoPopup">Watch Intro Video <i class="arrowRight fas fa-arrow-alt-circle-right"></i></button>
          </div>
          <div class="col-lg-6 mb-60">
            <img class="Canon_Vsion_Stand" src="@/assets/images/landing/CanonVision_Web_Gallery.gif" alt="">
          </div>
        </div>
        <div class="actions mb-60 d-none">
          <div class="row">
            <div class="col-lg-12">
              <button type="button" class="Btn">{{ $t("landing.ctaButton") }} <i class="arrowRight fas fa-arrow-alt-circle-right"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="imgBlock mb-0">
      <img src="@/assets/images/landing/imageBlock.jpg" alt="">
    </div>
    <div class="videoPopup" :class="{ active : videoPopup }">
      <div class="close" @click="clickCloseVideoPopup">
        <p>X</p>
      </div>
      <div class="fluidMedia active">
        <iframe class="carousel__iframe" :src="videoPopupURL" width="100%" frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import CookiePopup from '@/components/cookies/Popup'
import LanuageSelector from '@/snippets/lang/LanuageSelector.vue'
import i18n from '@/plugins/i18n';
const Bowser = require("bowser");
const currentBrowser = Bowser.getParser(window.navigator.userAgent);
export default {
  name: "Home",
  title: "Canon Vision: A Virtual Trade Show",
  components: {
    CookiePopup,
    LanuageSelector
  },
  data: () => ({
    showthankyou: false,
    popupMessage: true,
    virtualEvent: false,
    canonVisonUrl: "",
    videoPopup: false,
    videoPopupURL: "",
    browser: "",
    browserVersion: "",
    operatingSystem: "",
    compatable: true,
    notcompatable: false,
    firefox: true,
  }),
  created() {
    this.browser = currentBrowser.getBrowserName()
    this.browserVersion = currentBrowser.getBrowserVersion()
    this.operatingSystem = currentBrowser.getOSName()
    if(this.browser === "Chrome" || this.browser === "Opera"){
      if(this.operatingSystem === "iOS" || this.operatingSystem === "iPadOS") {
        this.compatable = false
        this.notcompatable = true
        // } else if(this.operatingSystem === "Windows") {
        //   this.compatable = false
        //   this.notcompatable = true
        //   this.firefox = false
      } else {
        this.compatable = true
        this.notcompatable = false
      }
    } else if (this.browser === "Firefox"){
      if(this.operatingSystem === "Windows") {
        this.compatable = false
        this.notcompatable = true
        this.firefox = false
      } else {
        this.compatable = true
        this.notcompatable = false
      }
    } else if (this.browser === "Microsoft Edge") {
      if(this.browserVersion >=	"83") {
        this.compatable = true
        this.notcompatable = false
      } else {
        this.compatable = false
        this.notcompatable = true
      }
    } else {
      this.compatable = false
      this.notcompatable = true
    }
  },
  methods: {
    langSpanish(value){
      let langSpanish = value.target.innerText
      console.log(langSpanish)
      if(langSpanish === 'English'){
        console.log(langSpanish + 'EN')
        i18n.locale = 'en'
      }
      else if(langSpanish === 'Español'){
        console.log(langSpanish + 'ES')
        i18n.locale = 'es'
      } else if(langSpanish === 'Français'){
        console.log(langSpanish + 'Fr')
        i18n.locale = 'fr'
      } else if(langSpanish === 'Italiano'){
        console.log(langSpanish + 'It')
        i18n.locale = 'it'
      } else if(langSpanish === 'Deutsch'){
        console.log(langSpanish + 'de')
        i18n.locale = 'de'
      } else if(langSpanish === 'Pусский'){
        console.log(langSpanish + 'ru')
        i18n.locale = 'ru'
      } else{
        console.log('Unknown')
      }
    },
    clickAcceptPopup(){
      this.popupMessage = false
      this.virtualEvent = true
      this.canonVisonUrl = "https://democanon.reydar.com/player/"
    },
    clickDeclinePopup(){
      window.location.replace("https://www.canon.co.uk/pro/events/canon-vision/");
    },
    clickVideoPopup(){
      this.videoPopup = true
      this.videoPopupURL = "https://player.vimeo.com/video/466151842?autoplay=1&loop=1&autopause=0"
    },
    clickCloseVideoPopup(){
      this.videoPopup = false
      this.videoPopupURL = ""
    }
  }
};
</script>


<style lang="scss" scoped>
@import "@/assets/sass/pageTemplates/basicPage.scss";
.template-basicPage{
  .loginLink{
    position: absolute;
    top: 90px;
    right: 16.7vw;
    p{
      color: #fff !important;
    }
  }
  .Btn{
    background-color: $color5;
    border: none;
    border-radius: 30px;
    padding: 6px 10px 6px 30px;
    font-size: 20px;
    font-weight: 600;
    color: $color4;
    i.arrowRight{
      margin-left: 30px;
      color: $color1;
      font-size: 22px;
    }
  }
  .Btn:hover{
    background-color: $color1;
    color: $color3;
    i.arrowRight{
      color: $color3;
    }
  }
  .videoPopup{
    position: fixed;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0,0,0,0.8);
    z-index: 999999;
    top: 0;
    left: 0;
    display: none;
    // padding: 120px;
    .close{
      position: fixed;
      top: 30px;
      right: 30px;
      z-index: 9999999;
      opacity: 1;
      background-color: $color3;
      border: solid 1px $color3;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      overflow: hidden;
      padding: 4.5px 7.5px;
      cursor: pointer;
      p{
        margin: 0px;
        font-size: 18px;
        color: $color1 !important;
        outline: none !important;
        box-shadow: none !important;
        border: none !important;
      }
    }
    .close:hover{
      opacity: 1;
      background-color: $color1;
      p{
        color: $color3 !important;
      }
    }
    .fluidMedia{
      display: none;
      position: relative;
      padding-bottom: 56.25%; /* proportion value to aspect ratio 16:9 (9 / 16 = 0.5625 or 56.25%) */
      height: 0;
      overflow: hidden;
      iframe{
        position: absolute;
        top: -10%;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        width: 75%;
        height: 75%;
      }
    }
    .fluidMedia.active{
      display: block;
    }
  }
  .videoPopup.active{
    display: block;
  }
  .canonStream{
    margin-bottom: 60px;
    .fluidMedia{
      display: none;
      position: relative;
      padding-bottom: 56.25%; /* proportion value to aspect ratio 16:9 (9 / 16 = 0.5625 or 56.25%) */
      height: 0;
      overflow: hidden;
      .virtualEvent{
        display: none;
        iframe{
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
      }
      .virtualEvent.active{
        display: block;
      }
      .popupMessage{
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url('https://res.cloudinary.com/enginecreative/image/upload/v1602159749/Canon/Reydar_CanonVision_Reception_voxqby.jpg') no-repeat center;
        background-size: cover !important;
      }
      .popupMessage.active{
        display: block;
      }
      .form{
        position: absolute;
        height: fit-content;
        width: 70%;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        padding: 30px !important;
      }
      .actions{
        // position: absolute;
        // width: fit-content;
        // bottom: -60px;
        // left: 0;
        // right: 0;
        // margin: 0 auto;
        margin-top: 15px;
        .Btn{
          background-color: $color5;
          border: none;
          border-radius: 30px;
          padding: 6px 10px 6px 30px;
          font-size: 20px;
          font-weight: 600;
          color: $color4;
          i.arrowRight{
            margin-left: 30px;
            color: $color1;
            font-size: 22px;
          }
        }
        .Btn:hover{
          background-color: $color1;
          color: $color3;
          i.arrowRight{
            color: $color3;
          }
        }
        .Btn:last-child{
          background-color: $color1;
          color: $color3;
          i.arrowRight{
            color: $color3;
          }
        }
        .Btn:last-child:hover{
          background-color: $color5;
          color: $color4;
          i.arrowRight{
            color: $color1;
          }
        }
      }
    }
    .fluidMedia.active{
      display: block;
    }
  }
  .container{
    max-width: 95% !important;
    h2{
      margin-bottom: 20px !important;
      margin-top: 0px !important;
    }
    p.openingPara{
      font-size: 20px !important;
      margin-bottom: 60px !important;
    }
    .actions{
      margin-bottom: 80px;
    }
    h3{
      font-size: 26px !important;
      margin-top: 0px !important;
    }
    img.Canon_Vsion_Stand{
      width: 95%;
      float: right;
      height: 100%;
      object-fit: contain;
      padding-top:15px;
    }
  }
  .imgBlock{
    margin-bottom: 60px;
  }
}
.thankyou{
  margin-bottom: 90px;
  p{
    color: $color4;
    line-height: 32px;
  }
}
@media (min-width: 2400px){
  .loginLink{
    position: absolute;
    width: fit-content;
    top: 90px;
    left: 45% !important;
    right: 0 !important;
    margin: 0 auto;
  }
}
@media (max-width: 1400px) and (min-width: 1000px){
  .fluidMedia{
    padding-bottom: 75% !important;
  }
}
@media (max-width: 1000px) and (min-width: 900px){
  .fluidMedia{
    padding-bottom: 150% !important;
  }
}
@media (max-width: 900px) and (min-width: 850px){
  .fluidMedia{
    padding-bottom: 150% !important;
  }
}
@media (max-width: 850px){
  .fluidMedia{
    padding-bottom: 150% !important;
  }
}
@media (max-width: 900px){
  .popupMessage.mobile.active{
    .form{
      padding: 0px 0px 15px 0px !important;
      p{
        padding: 0px 15px !important;
        margin-bottom: 15px !important;
      }
      img{
        width: 100%;
        margin-bottom: 15px;
      }
      img.AppDownload{
        width: 33%;
        margin-bottom: 0px;
      }
      img.ReydarLogoApp{
        width: 33%;
        margin-bottom: 0px;
        margin-right: 8%;
      }
    }
  }
}
@media (min-width: 768px){
  .template-basicPage{
    .container{
      p.openingPara{
        padding: 0 11vw;
      }
    }
  }
  .popupMessage.active{
    display: block !important;
  }
  .popupMessage.active.mobile{
    display: none !important;
  }
}
@media (max-width: 768px){
  .loginLink{
    position: absolute;
    width: fit-content;
    top: 10px !important;
    left: 0 !important;
    right: 0 !important;
    margin: 0 auto;
  }
  .template-basicPage{
    .container{
      .paraSection.mb-60{
        margin-bottom: 30px !important;
      }
      img.Canon_Vsion_Stand{
        padding: 0px;
        width: 100%;
      }
    }
    .imgBlock{
      width: 100%;
      overflow: hidden;
      img{
        width: 200%;
      }
    }
  }
  .popupMessage.active{
    display: none !important;
  }
  .popupMessage.active.mobile{
    display: block !important;
  }
  .popupMessage.mobile{
    background: url('https://res.cloudinary.com/enginecreative/image/upload/v1602150932/Canon/canon-reydar_gooymb.png') no-repeat center;
    background-size: cover !important;
    .form{
      width: 85% !important;
      height: fit-content !important;
      text-align: center;
      padding: 0px !important;
      padding-left: 15px !important;
      padding-right: 15px !important;
      padding-top: 15px !important;
      padding-bottom: 15px !important;
    }
  }
}
</style>

<style lang="scss">
@media (min-width: 768px){
  .template-footer{
    position: fixed;
    bottom: 0;
    width: 100vw;
  }
}
</style>
